export default __webpack_public_path__ + "static/media/Logo image.f51c1c55.svg";